import React, { useEffect, useMemo, useState } from 'react';

import { makeStyles } from '@material-ui/core';

import useIsMounted from '../hooks/useIsMounted';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    overflow: 'hidden',

    '& > img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },

    '& > svg': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },
  '@keyframes ov-pulse': {
    '0%': { color: '#EBF2F3' },
    '50%': { color: '#4bb4b3' },
    '100%': { color: '#EBF2F3' },
  },
  loading: {
    color: '#EBF2F3',
    animationName: 'ov-pulse',
    animationDuration: '2s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in',
  },
  placeholder: {
    color: '#EBF2F3',
  },
  placeholderWhite: {
    color: '#fff',
  },
});

const Logo = ({ size = 30, ...restProps }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 455.376 454.976"
      {...restProps}
    >
      <path
        d="M197.038 221.438a31.2 31.2 0 1024.5-24.5 31.181 31.181 0 00-24.5 24.5zm18.6-79.8a86.556 86.556 0 0112.5-.9 80.23 80.23 0 0111 .7 7.721 7.721 0 008-4.6l51.8-124.4a5.646 5.646 0 00-3.6-7.6c-6.1-1.8-12.3-3.4-18.5-4.7a5.511 5.511 0 00-6.4 3.4l-41.8 99.7a.975.975 0 01-1.8 0l-42.7-98.8a5.732 5.732 0 00-6.5-3.3c-7.1 1.6-14 3.6-20.8 5.8a5.619 5.619 0 00-3.4 7.7l54.1 122.6a7.65 7.65 0 008.1 4.4zm98.1 74.4a86.556 86.556 0 01.9 12.5 80.23 80.23 0 01-.7 11 7.721 7.721 0 004.6 8l124.4 51.8a5.646 5.646 0 007.6-3.6c1.8-6.1 3.4-12.3 4.7-18.5a5.511 5.511 0 00-3.4-6.4l-99.7-41.9a.975.975 0 010-1.8l98.8-42.7a5.732 5.732 0 003.3-6.5c-1.6-7.1-3.6-14-5.8-20.8a5.619 5.619 0 00-7.7-3.4l-122.6 54.2a7.65 7.65 0 00-4.4 8.1zm-74.5 97.3a86.556 86.556 0 01-12.5.9 80.23 80.23 0 01-11-.7 7.721 7.721 0 00-8 4.6l-51.8 124.4a5.646 5.646 0 003.6 7.6c6.1 1.8 12.3 3.4 18.5 4.7a5.511 5.511 0 006.4-3.4l41.8-99.7a.975.975 0 011.8 0l42.7 98.8a5.732 5.732 0 006.5 3.3c7.1-1.6 14-3.6 20.8-5.8a5.619 5.619 0 003.4-7.7l-54.1-122.6a7.65 7.65 0 00-8.1-4.4zm40.8-154.9a91.48 91.48 0 019.5 8.2 81.79 81.79 0 017.3 8.3 7.643 7.643 0 008.9 2.4l124.6-51.3a5.648 5.648 0 002.8-7.9c-3-5.6-6.3-11-9.8-16.4a5.717 5.717 0 00-6.9-2.2l-100.1 40.9a1.016 1.016 0 01-1.3-1.3l39.7-100.1a5.681 5.681 0 00-2.3-6.9 205.222 205.222 0 00-18.8-10.6 5.639 5.639 0 00-7.8 3l-48.4 125a7.745 7.745 0 002.6 8.9zm-104.7 138.1a91.478 91.478 0 01-9.5-8.2 81.794 81.794 0 01-7.3-8.3 7.643 7.643 0 00-8.9-2.4l-124.6 51.4a5.648 5.648 0 00-2.8 7.9c3 5.6 6.3 11 9.8 16.4a5.717 5.717 0 006.9 2.2l100.1-40.9a1.016 1.016 0 011.3 1.3l-39.8 100a5.681 5.681 0 002.3 6.9 205.226 205.226 0 0018.8 10.6 5.639 5.639 0 007.8-3l48.4-125a7.645 7.645 0 00-2.5-8.9zm121.4-16.6a91.48 91.48 0 01-8.2 9.5 81.792 81.792 0 01-8.3 7.3 7.643 7.643 0 00-2.4 8.9l51.3 124.6a5.648 5.648 0 007.9 2.8c5.6-3 11-6.3 16.4-9.8a5.717 5.717 0 002.2-6.9l-40.9-100.1a1.016 1.016 0 011.3-1.3l100 39.8a5.681 5.681 0 006.9-2.3 205.227 205.227 0 0010.6-18.8 5.639 5.639 0 00-3-7.8l-125-48.4a7.5 7.5 0 00-8.8 2.5zm-138.1-104.7a91.478 91.478 0 018.2-9.5 81.792 81.792 0 018.3-7.3 7.643 7.643 0 002.4-8.9l-51.4-124.6a5.648 5.648 0 00-7.9-2.8c-5.6 3-11 6.3-16.4 9.8a5.717 5.717 0 00-2.2 6.9l40.9 100.1a1.016 1.016 0 01-1.3 1.3l-100.1-39.7a5.681 5.681 0 00-6.9 2.3 205.22 205.22 0 00-10.6 18.8 5.639 5.639 0 003 7.8l125 48.4a7.935 7.935 0 009-2.6zm-16.9 64.7a86.556 86.556 0 01-.9-12.5 80.23 80.23 0 01.7-11 7.721 7.721 0 00-4.6-8l-124.5-51.8a5.646 5.646 0 00-7.6 3.6c-1.8 6.1-3.4 12.3-4.7 18.5a5.511 5.511 0 003.4 6.4l99.7 41.8a.975.975 0 010 1.8l-98.8 42.7a5.732 5.732 0 00-3.3 6.5c1.6 7.1 3.6 14 5.8 20.8a5.619 5.619 0 007.7 3.4l122.6-54.1a7.722 7.722 0 004.5-8.1z"
        fill="currentColor"
      />
    </svg>
  );
};

const loadImage = (src: string) =>
  new Promise<string>((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.decoding = 'async';

    if (typeof img.decode !== 'undefined') {
      img
        .decode()
        .then(() => resolve(img.src))
        .catch(() => reject(new Error('Error decoding image.')));
    } else {
      img.onload = () => {
        resolve(img.src);
      };
    }

    img.onerror = () => {
      reject(new Error('Error downloading image.'));
    };
  });

interface IImage2 extends React.HTMLAttributes<HTMLDivElement> {
  src: string | unknown;
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  useWhitePlaceholder?: boolean;
  imageProps?: React.HTMLAttributes<HTMLImageElement>;
}

const Image2 = ({
  src,
  width = 'auto',
  height = 'auto',
  style = {},
  useWhitePlaceholder = false,
  imageProps = {},
  ...restProps
}: IImage2) => {
  const isMounted = useIsMounted();
  const classes = useStyles();

  const [isLoading, setLoading] = useState<boolean>(false);
  const [hadError, setError] = useState<boolean>(false);
  const [displaySrc, setDisplaySrc] = useState<string>('');

  useEffect(() => {
    setLoading(true);
    if (typeof src === 'string') {
      loadImage(src)
        .then((resolvedSrc: string) => {
          if (isMounted.current) {
            setDisplaySrc(resolvedSrc);
            setLoading(false);
          }
        })
        .catch(() => {
          if (isMounted.current) {
            setError(true);
            setLoading(false);
          }
        });
    } else {
      // incorrect src format, default to error
      setError(true);
      setLoading(false);
    }
  }, []);

  const localStyle = useMemo(
    () => ({
      width: typeof width === 'string' ? width : `${width}px`,
      height: typeof height === 'string' ? height : `${height}px`,
      ...style,
    }),
    [width, height, style],
  );

  return (
    <div className={classes.container} style={localStyle} {...restProps}>
      {isLoading && <Logo className={classes.loading} />}
      {!isLoading && hadError && (
        <Logo className={useWhitePlaceholder ? classes.placeholderWhite : classes.placeholder} />
      )}
      {!isLoading && !hadError && <img src={displaySrc} alt="" {...imageProps} />}
    </div>
  );
};

export default Image2;
